import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ChangeSpocPasswordRPC } from "./changeSpocPasswordRPC";

export class ChangeSpocPasswordRPCClientImpl extends ChangeSpocPasswordRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ChangeSpocPasswordRPC.Request): Promise<LeoRPCResult<ChangeSpocPasswordRPC.Response, ChangeSpocPasswordRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/ChangeSpocPassword",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ChangeSpocPasswordRPC.ResponseDTO,
      ChangeSpocPasswordRPC.Errors.ErrorsDTO,
      ChangeSpocPasswordRPC.Response,
      ChangeSpocPasswordRPC.Errors.Errors
    >(
      response,
      "spoc-management/ChangeSpocPassword",
      ChangeSpocPasswordRPC.Response.fromDTO,
      ChangeSpocPasswordRPC.Errors.fromDTO
    );
  }
}
